import { useState } from 'react'

import { useFilePreviewGallery } from '../../../../../../../FilesPreviewGallery'
import { getPhotoCoverIndex } from '../../../../../../RentalPortalPhotoGallery'
import {
  getListingMosaicLeadIndex,
  toListingMosaicPreviewPhotos,
} from '../../RentalPortalListingPhotoMosaic.utils'

export function useListingPhotoMosaic({ photos }) {
  const [leadPhotoId, setLeadPhotoId] = useState(null)

  const previewPhotos = toListingMosaicPreviewPhotos(photos)

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files: previewPhotos })

  const activeLeadIndex = getListingMosaicLeadIndex({
    coverIndex: getPhotoCoverIndex(photos),
    leadPhotoId,
    photos,
  })

  function handleClickLead() {
    handleClickFile(photos[activeLeadIndex].id)
  }

  function handleClickThumbnail(photo) {
    setLeadPhotoId(photo.id)
  }

  function handleClickMore(photo) {
    handleClickFile(photo.id)
  }

  return {
    activeFileIndex,
    activeLeadIndex,
    handleClickLead,
    handleClickMore,
    handleClickThumbnail,
    handleCloseFilePreview,
    previewPhotos,
  }
}
